// Keep aligned with lib/metadata-transforms/metadata-authoring/src/roots.js.
export default Object.freeze(['menu_Menu', 'menu_MeatballProfileLayout', 'profileMenu_MeatballProfileLayout']);
